import { useEffect, useRef, useState } from "react";
import Block from "./Block";

export default function ContentSnippet({ value = [], onChange, hasError, editable }) {
  const isInitialLoad = useRef(true);

  const [blocks, setBlocks] = useState([]);

  function createEmptyBlock() {
    return {
      id: crypto.randomUUID(),
      type: 'Text',
      data: null,
      style: null,
      autoOpen: true,
    };
  }
  function updateBlock(id, changes) {
    setBlocks((prev) =>
      prev.map((block) =>
        block.id === id ? { ...block, ...changes } : block
      )
    );
  }
  function moveBlock(index, direction) {
    setBlocks((prev) => {
      const newBlocks = [...prev];
      const targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= newBlocks.length) return prev;
      [newBlocks[index], newBlocks[targetIndex]] = [
        newBlocks[targetIndex],
        newBlocks[index],
      ];
      return newBlocks;
    });
  }
  function removeBlock(id) {
  setBlocks((prev) => {
    const newBlocks = prev.filter((block) => block.id !== id);
    
    if (newBlocks.length === 0) {
      isInitialLoad.current = false;
    }
    
    return newBlocks;
  });
}
  function handleBlockIncrease() {
    isInitialLoad.current = false;
    setBlocks((prev) => [...prev, createEmptyBlock()]);
  }

  useEffect(() => {
    
    if (!isInitialLoad.current) return;
    
    if (Array.isArray(value) && value.length > 0) {
      const normalizedBlocks = value.map((item) => ({
        id: crypto.randomUUID(),
        type: item.type,
        data: item.content ?? "",
        style: item.idStyle ? { value: item.idStyle } : null,
        autoOpen: false,
      }));
    setBlocks(normalizedBlocks);
    isInitialLoad.current = false;
  }
    
  }, [value, blocks.length]);
  useEffect(() => {
    const payload = blocks.map((block, index) => ({
      order: index,
      type: block.type,
      content: block.data,
      idStyle: block.style?.value ?? null,
    }));

    onChange?.(payload);
  }, [blocks, onChange]);

  return (
    <div>
      {blocks.map((block, index) => {
        const isBlockInvalid = hasError && (!block.data || (typeof block.data === "string" && block.data.trim() === ""));
        return (
          <Block
            key={block.id}
            block={block}
            index={index}
            isFirst={index === 0}
            isLast={index === blocks.length - 1}
            onMoveUp={() => moveBlock(index, -1)}
            onMoveDown={() => moveBlock(index, 1)}
            
            
            onChangeData={(data) =>
              updateBlock(block.id, { data })
            }
            onChangeStyles={(style) =>
              updateBlock(block.id, { style })
            }
            onDelete={() => 
              removeBlock(block.id)
            }
            
            blockCount={blocks.length}
            hasError={isBlockInvalid}
            editable={editable}
          />
        );
      })}

      {
        !editable && (
          <div className="block-wrap">
            <button
              type="button"
              className="block-add"
              onClick={handleBlockIncrease}
            >
              <div className="block-add-icon">
                <i className="fa fa-plus"></i>
              </div>
              <div className="block-add-text">Add Content</div>
            </button>
          </div>
        )
      }
    </div>
  );
}
